export default "__VITE_ASSET__Bi0IQkfR__"